import {
  BackgroundImage,
  Center,
  Text,
  Box,
  Button,
  Group,
  Card,
  Grid,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import useTransferByAccountStore from "stores/TransferByAccountStore/transferByAccountStore";
import { useNavigate } from "react-router-dom";
import background from "assets/images/pngs/background.png";
import React from "react";
import { v4 as uuidv4 } from "uuid"; // Import uuid

type LoanCompletedProps = {
  img: string;
  title: string;
  amount: string;
  form: any;
  addNew: () => void;
};

type LoanDetailItem = {
  label: string;
  content: string;
};

type LoanDetailInfoProps = {
  details: LoanDetailItem[];
};

export const LoanDetailInfo: React.FC<LoanDetailInfoProps> = ({ details }) => {
  return (
    <Box m="40px">
      {details.map((item) => (
        <DetailItem key={uuidv4()} label={item.label} content={item.content} />
      ))}
    </Box>
  );
};
const DetailItem = ({ label, content }: { label: string; content: string }) => {
  return (
    <Grid gutter="xs" align="center" style={{ marginBottom: "16px" }}>
      <Grid.Col span={6} style={{ textAlign: "left" }}>
        <Text size="16px" color="#0E121B">
          {label}
        </Text>
      </Grid.Col>

      <Grid.Col span={6} style={{ textAlign: "right" }}>
        <Text size="16px" weight={600} color="#0E121B">
          {content}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

export const LoanCompleted: React.FC<LoanCompletedProps> = ({
  img,
  title,
  amount,
  form,
  addNew,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [stateTransferByAccountStore, actionTransferByAccountStore] =
    useTransferByAccountStore();

  return (
    <>
      <Group position="center">
        <Card withBorder shadow="sm" radius="md" pb="20px" w="50%">
          <div className="flex flex-col content-center gap-2 bg-white w-full">
            <div className="flex flex-col justify-center items-center">
              <img src={img} alt="test" className="my-2 h-48 w-48" />
              <Text weight={600}>{title}</Text>
            </div>
            <Box w="100%">
              <BackgroundImage src={background} radius="md" className="w-full">
                <Center p="lg">
                  <Text size={32} weight={800} sx={{ color: "white" }}>
                    {amount} VND
                  </Text>
                </Center>
              </BackgroundImage>
            </Box>
          </div>
          {/* <LoanDetailInfo
            details={[
              { label: t("REFERENCE_CODE"), content: "DF330035253231" },
              { label: t("DEPOSIT_AMOUNT"), content: "150,000,000 VND" },
              { label: t("TERM_TYPE"), content: t("6_MONTHS_-_10%/YEAR") },
              {
                label: t("EXPECTED_PROFIT_AT_THE_END_OF_THE_PERIOD"),
                content: "105,000,000 VND",
              },
              {
                label: t("FORM_OF_RENEWAL_OF_PRINCIPAL_AND_INTEREST"),
                content: t("REVOLVING_PRINCIPAL_INTEREST"),
              },
              { label: t("CREATOR:"), content: "Duyna" },
              { label: t("DATE_CREATED:"), content: "26/03/2024  15:30" },
            ]}
          /> */}
          {form}
        </Card>
      </Group>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="flex items-center justify-between gap-4 mt-4 w-1/2">
          <Button
            variant="outline"
            sx={{
              color: "#2A81D0",
              borderColor: "#2A81D0",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#F0F5FF",
              },
            }}
            fullWidth
            onClick={() => {
              navigate("/");
            }}
          >
            {t("HOME")}
          </Button>
          <Button
            variant="filled"
            sx={{
              backgroundColor: "#2A81D0",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#1E679E",
              },
            }}
            fullWidth
            onClick={addNew}
          >
            {t("ADD_NEW_TRANSACTION")}
          </Button>
        </div>
      </Box>
    </>
  );
};
